export const SET_DONATION_LOADING = "SET_DONATION_LOADING";

export const SET_DONATION_LIST_AND_TOTAL = "SET_DONATION_LIST_AND_TOTAL";
